import { combineReducers } from "redux-immutable";

import CoursesStateSlice from "../../models/state/CoursesStateSlice";

import courses from "./courses";
import sections from "./sections";
import contents from "./contents";
import modules from "./modules";
import meta from "./meta";

export default combineReducers(
  {
    courses,
    sections,
    contents,
    modules,
    meta
  },
  () => new CoursesStateSlice() as any
);
